import React from 'react'
import { Input, Tooltip, Card, Button } from 'antd'
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons'
import { useFormikContext, FieldArray } from 'formik'
import { FormField, ArrayItemCard, RemoveButton } from './shared'
import { useFieldPath } from './TabContext'
import { get } from 'lodash'

export const SchemaMetadataSection: React.FC = () => {
  const { values, setFieldValue } = useFormikContext<any>()

  // Paths dos campos para o tab atual
  const productTitlePath = useFieldPath('productTitle')
  const skuPath = useFieldPath('sku')
  const totalHistoricalEnrollmentPath = useFieldPath('totalHistoricalEnrollment')
  const datePublishedPath = useFieldPath('datePublished')
  const aboutPath = useFieldPath('about')

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFieldValue(e.target.name, e.target.value)
  }

  return (
    <Card>
      <FormField>
        <label>
          <Tooltip title="Título do produto usado em schemas (JSON-LD, Product, Course, etc.)">
            Título do Produto (Schema)
          </Tooltip>
        </label>
        <Input
          name={productTitlePath}
          value={get(values, productTitlePath, '')}
          onChange={handleChange}
          placeholder="Ex: Curso de Atualização para Motofretistas"
        />
      </FormField>

      <FormField>
        <label>
          <Tooltip title="SKU único para o produto (usado em schemas e integrações)">SKU</Tooltip>
        </label>
        <Input
          name={skuPath}
          value={get(values, skuPath, '')}
          onChange={handleChange}
          placeholder="Ex: CURSO-ATU-MOTOFRETE-2025"
        />
      </FormField>

      <FormField>
        <label>
          <Tooltip title="Quantidade total histórica de matrículas no curso (para prova social no schema)">
            Matrículas Históricas Totais
          </Tooltip>
        </label>
        <Input
          name={totalHistoricalEnrollmentPath}
          type="number"
          value={get(values, totalHistoricalEnrollmentPath, '')}
          onChange={handleChange}
          placeholder="Ex: 15342"
        />
      </FormField>

      <FormField>
        <label>
          <Tooltip title="Data de publicação no formato ISO (AAAA-MM-DD). Exemplo: 2024-01-10">
            Data de Publicação
          </Tooltip>
        </label>
        <Input
          name={datePublishedPath}
          type="text"
          value={get(values, datePublishedPath, '')}
          onChange={handleChange}
          placeholder="Ex: 2024-01-10"
          maxLength={10}
        />
      </FormField>

      <h4>About (tópicos curtos)</h4>
      <FieldArray name={aboutPath}>
        {(arrayHelpers) => {
          const aboutList = get(values, aboutPath, [])

          return (
            <>
              {aboutList.map((item, index) => (
                <ArrayItemCard key={index}>
                  <RemoveButton>
                    <Button
                      type="text"
                      danger
                      size="small"
                      icon={<DeleteOutlined />}
                      onClick={() => arrayHelpers.remove(index)}
                    />
                  </RemoveButton>

                  <FormField>
                    <label>About #{index + 1}</label>
                    <Input
                      name={`${aboutPath}.${index}`}
                      value={item}
                      onChange={handleChange}
                      placeholder="Ex: Transporte de Emergência"
                    />
                  </FormField>
                </ArrayItemCard>
              ))}

              <Button
                type="dashed"
                onClick={() => arrayHelpers.push('')}
                block
                icon={<PlusOutlined />}
              >
                Adicionar About
              </Button>
            </>
          )
        }}
      </FieldArray>
    </Card>
  )
}
